import { useSelector } from 'react-redux';
import { getModelJson } from 'features/page-model';
import { getArticle } from 'common/selectors';
import { useMemo } from 'react';

export function useStretchBannerData() {
  const modelJson = useSelector(getModelJson);
  const productId = useSelector(getArticle);

  const bannerConfig = modelJson?.rmBannerRastyazhka;

  const stretchBannerData = useMemo(() => {
    if (bannerConfig && productId) {
      const {
        placementId,
        height,
        width,
        gaName,
        gaPosition,
        viewingTime,
        targetBlank,
        closeButton,
        autohide,
        autohideViews,
      } = bannerConfig;
      return {
        showWithoutErid: true,
        pageType: 'productPlacements',
        requestData: { placements: { web: placementId }, productId: productId },
        fullWidth: true,
        closeButton: closeButton,
        autohide: autohide,
        autohideViews: autohideViews,
        width: width,
        height: height,
        gaPosition: gaPosition,
        gaName: gaName,
        targetBlank: targetBlank,
        viewingTime: viewingTime,
      };
    }
  }, [bannerConfig, productId]);

  return { stretchBannerData };
}
